/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SubtitleInputs */

const en_contact_subtitle = /** @type {(inputs: Contact_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us how your desk publishes today and who consumes it. We will walk you through what Inginuiti looks like on your own library.`)
};

/**
* | output |
* | --- |
* | "Tell us how your desk publishes today and who consumes it. We will walk you through what Inginuiti looks like on your own library." |
*
* @param {Contact_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_subtitle = /** @type {((inputs?: Contact_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_subtitle(inputs)
});